export const osStatusKeys = {
  Alive: "Living",
  Dead: "Deceased",
  No: "Deceased",
  Yes: "Living",
};

export const initialDbsState = [
  {
    hasData: false,
    isChecked: true,
    label: "ICGC Somatic",
    data: null,
    samples: 0,
  },
  {
    hasData: false,
    isChecked: true,
    label: "ΙΑRCTP53 Somatic",
    data: null,
    samples: 0,
  },
  {
    hasData: false,
    isChecked: true,
    label: "ΙΑRCTP53 Germline",
    data: null,
    samples: 0,
  },
  {
    hasData: false,
    isChecked: true,
    label: "Cancer Hotspots",
    data: null,
    samples: 0,
  },
  { hasData: false, isChecked: true, label: "GDC", data: null, samples: 0 },
  {
    hasData: false,
    isChecked: true,
    label: "cBioPortal",
    data: null,
    samples: 0,
  },
];
